import React from "react";
import EncuestaTemplate from "../components/templates/EncuestaTemplate";

const EncuestaPage = () => {
	return <EncuestaTemplate />;
};

export default EncuestaPage;
